import { IEnvironment } from './environment.base';

export const environment: IEnvironment = {
  name: 'development',
  production: false,
  apiUrls: {
    worker: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/worker',
    loads: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/loads',
    tickets: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/tickets',
    security: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/security',
    users: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/user',
    files: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/files',
    workflow: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/v1/wk',
    receivable: 'https://app-evl-evlos-boletagem-api.azurewebsites.net/api/receivables',
  },
  duplicateTicketDateLimit: '2019-09-24T03:00:00'
};
